var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "node-tree nav-item cursor-pointer",
      class: { "has-treeview": _vm.isGroup, "d-none": !_vm.filtered },
      attrs: { "data-id": _vm.node.id },
    },
    [
      _vm.isGroup
        ? [
            !_vm.isRoot || (_vm.isRoot && _vm.showRoot)
              ? _c(
                  "div",
                  {
                    staticClass: "nav-link group d-flex align-items-center",
                    class: { selected: _vm.selected && _vm.activeSelect },
                    attrs: { "aria-expanded": !_vm.collapsed },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleEvent("selected", _vm.node, $event)
                      },
                    },
                  },
                  [
                    !_vm.loading
                      ? _c(
                          "div",
                          {
                            staticClass: "nav-icon",
                            style: {
                              "background-color": _vm.node.icon_bg_color
                                ? _vm.node.icon_bg_color
                                : "",
                            },
                          },
                          [
                            _c("i", {
                              class: _vm.node.icon
                                ? _vm.node.icon
                                : "fas fa-th",
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showCheckbox && !_vm.loading
                      ? _c("i", {
                          staticClass: "nav-icon-onoff far",
                          class: [
                            _vm.checked ? "fa-check-square" : "fa-square",
                          ],
                          attrs: {
                            "data-toggle": "tooltip-city",
                            title: "Toggle group visibility",
                            "data-placement": "top",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleEvent(
                                "checked",
                                _vm.node,
                                $event
                              )
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "nav-link-text" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.node.name) +
                          "\n\n                "
                      ),
                      _vm.hasChildren
                        ? _c(
                            "span",
                            {
                              staticClass: "right",
                              attrs: {
                                "data-toggle": "tooltip-city",
                                title: "Toggle Group Collapse/Open",
                                "data-placement": "top",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleEvent(
                                    "collapsed",
                                    _vm.node,
                                    $event
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "rotate-icon small svg-inline--fa fa-angle-down",
                                  attrs: {
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    "data-prefix": "fas",
                                    "data-icon": "angle-down",
                                    role: "img",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 256 512",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      fill: "currentColor",
                                      d: "M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        : [
            _c(
              "div",
              {
                staticClass: "nav-link layer",
                class: {
                  active: _vm.checked,
                  selected: _vm.selected && _vm.activeSelect,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleEvent("selected", _vm.node, $event)
                  },
                },
              },
              [
                _vm.showCheckbox && !_vm.loading
                  ? _c("i", {
                      staticClass: "nav-icon-sm far",
                      class: [_vm.checked ? "fa-eye" : "fa-eye-slash"],
                      attrs: {
                        "data-toggle": "tooltip-city",
                        title: "Toggle layer visibility",
                        "data-placement": "top",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleEvent("checked", _vm.node, $event)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.iconLayer
                  ? _c("img", {
                      staticClass: "img-icon-layer",
                      attrs: {
                        src: _vm.iconLayer,
                        loading: "lazy",
                        alt: "...",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "nav-link-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.node.name) +
                      "\n\n                "
                  ),
                  _vm.enableLegendLayer
                    ? _c(
                        "span",
                        {
                          staticClass: "right",
                          attrs: {
                            "data-toggle": "tooltip-city",
                            title: "Display legend and tools",
                            "data-placement": "top",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleEvent(
                                "collapsed",
                                _vm.node,
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "nav-icon svg-inline--fa fa-ellipsis-h",
                              attrs: {
                                "aria-hidden": "true",
                                focusable: "false",
                                "data-prefix": "fas",
                                "data-icon": "ellipsis-h",
                                role: "img",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  fill: "currentColor",
                                  d: "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.checked || !_vm.collapsed
              ? _c(
                  "div",
                  { staticClass: "row align-items-center no-gutters" },
                  [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("opacity-slider", {
                          staticClass: "layer-opacity-slider",
                          attrs: {
                            disabled: !_vm.checked,
                            id: `layer-slider-${_vm.node.id}`,
                            min: 0,
                            max: 1,
                            interval: 0.1,
                            contained: true,
                            tooltip: "always",
                            tooltipStyles: { right: 10 },
                            tooltipPlacement: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "dot",
                                fn: function ({ value, focus }) {
                                  return [
                                    _c("div", {
                                      staticClass: "vue-slider-dot-handle",
                                      class: ["custom-dot", { focus }],
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "tooltip",
                                fn: function ({ value, focus }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "layer-opacity-slider-tooltip-inner opacity-slider-tooltip-inner-right",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "layer-opacity-slider-tooltip-text",
                                            class: [{ focus }],
                                          },
                                          [_vm._v(_vm._s(value * 100) + "%")]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            814639757
                          ),
                          model: {
                            value: _vm.opacity,
                            callback: function ($$v) {
                              _vm.opacity = $$v
                            },
                            expression: "opacity",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-auto node-actions" },
                      _vm._l(_vm.filteredActions, function (action, idx) {
                        return _c(
                          "button",
                          {
                            key: `node-action-${idx}`,
                            staticClass: "btn node-action",
                            attrs: {
                              title: action.title,
                              disabled: !_vm.checked,
                              type: "button",
                              "data-toggle": "tooltip-city",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.callNodeAction(action, $event)
                              },
                            },
                          },
                          [
                            action.icon
                              ? _c("i", { class: action.icon })
                              : action.image
                              ? _c("span", {
                                  domProps: { innerHTML: _vm._s(action.image) },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
          ],
      _vm._v(" "),
      _c("collapse-transition", [
        _vm.hasChildren || _vm.enableLegendLayer
          ? _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.collapsed,
                    expression: "!collapsed",
                  },
                ],
                staticClass: "nav nav-treeview cursor-default",
                class: {
                  "pl-0":
                    (_vm.isRoot && !_vm.showRoot) || _vm.enableLegendLayer,
                },
                attrs: { id: `sb-item-${_vm.node.id}` },
              },
              [
                _vm._l(_vm.node.children, function (child) {
                  return _c("node-tree-layers", {
                    key: `node-tree-${child.id}`,
                    ref: `node-tree-${child.id}`,
                    refInFor: true,
                    attrs: {
                      node: child,
                      parentNode: _vm.node,
                      depth: _vm.depth + 1,
                      map: _vm.map,
                      actions: _vm.actions,
                      showRoot: _vm.showRoot,
                      activeSelect: _vm.activeSelect,
                    },
                    on: {
                      emitNodeAction: _vm.emitNodeAction,
                      emitNodeChecked: _vm.emitNodeChecked,
                      emitNodeCollapsed: _vm.emitNodeCollapsed,
                      emitNodeSelected: _vm.emitNodeSelected,
                      emitNodeDeleted: _vm.emitNodeDeleted,
                      emitNodeAdded: _vm.emitNodeAdded,
                    },
                  })
                }),
                _vm._v(" "),
                _vm.enableLegendLayer && _vm.legendUrlLayer
                  ? _c(
                      "li",
                      { staticClass: "nav-item legend m-2" },
                      [
                        _c("layer-legend", {
                          key: `sb-item-legend-${_vm.node.id}`,
                          attrs: { url: _vm.legendUrlLayer },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }